import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="brand-name">MY OUTSOURCING</span>
        </div>
        <nav className="footer-nav">
          <NavLink to="/">{t("home")}</NavLink>
          <NavLink to="/service">{t("service")}</NavLink>
          <NavLink to="/team">{t("team")}</NavLink>
          <NavLink to="/career">{t("career")}</NavLink>
          <NavLink to="/contact">{t("contact")}</NavLink>
        </nav>
        <p className="footer-copyright">
          © {currentYear} My Outsourcing. {t("all_rights_reserved") || "All Rights Reserved"}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
